import * as React from 'react';
import { JSX } from 'react/jsx-runtime';

const BallIconDark = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.1107 9.1906L10.6667 8.79327V5.33594C10.6667 4.62869 10.3857 3.95042 9.88562 3.45032C9.38552 2.95022 8.70725 2.66927 8 2.66927C7.29276 2.66927 6.61448 2.95022 6.11439 3.45032C5.61429 3.95042 5.33334 4.62869 5.33334 5.33594V8.79327L4.88934 9.1906C4.24503 9.76558 3.77325 10.5083 3.52667 11.3359H12.4733C12.2268 10.5083 11.755 9.76558 11.1107 9.1906ZM10 12.6693C10 13.1997 9.78929 13.7084 9.41422 14.0835C9.03914 14.4586 8.53044 14.6693 8 14.6693C7.46957 14.6693 6.96086 14.4586 6.58579 14.0835C6.21072 13.7084 6 13.1997 6 12.6693H2C1.9991 11.825 2.17683 10.99 2.52152 10.2193C2.86622 9.44854 3.37008 8.75945 4 8.19727V5.33594C4 4.27507 4.42143 3.25766 5.17158 2.50751C5.92172 1.75736 6.93914 1.33594 8 1.33594C9.06087 1.33594 10.0783 1.75736 10.8284 2.50751C11.5786 3.25766 12 4.27507 12 5.33594V8.19727C12.6299 8.75945 13.1338 9.44854 13.4785 10.2193C13.8232 10.99 14.0009 11.825 14 12.6693H10ZM8 13.3359C8.17681 13.3359 8.34638 13.2657 8.47141 13.1407C8.59643 13.0157 8.66667 12.8461 8.66667 12.6693H7.33334C7.33334 12.8461 7.40357 13.0157 7.5286 13.1407C7.65362 13.2657 7.82319 13.3359 8 13.3359Z"
      fill="#EEF7FF"
    />
    <circle
      cx="3.2"
      cy="3.2"
      r="3.2"
      transform="matrix(-1 0 0 1 14.9336 0)"
      fill="#FF5E5E"
    />
  </svg>
);

export default BallIconDark;
